<template>
    <div class="section-card">
        <p class="heading mb-5">{{ heading }} Performance</p>
        <AreaLineChart :rawData="performanceData" />
    </div>
</template>
<script>
import AreaLineChart from '../../commonCharts/AreaLineChart.vue';

export default {
    name: 'PerformanceChart',
    components: {
        AreaLineChart,
    },
    props: {
        heading: String,
        performanceData: {
            type: Array,
            required: true
        }
    },
}
</script>
<style>
.card {
    border-radius: 0.7rem !important;
    border: none !important;
    margin-bottom: 1rem;
}
</style>